export default __webpack_public_path__ + "static/media/brainhack.fb31b135.png";